import { useAuth } from "@/components/contexts/AuthContext/UseAuth";
import { UserType } from "@/types/IdentityTypes";
import { useLandlordProfile } from "./useLandlordProfile";

export const useLandlordVerification = () => {
  const { data: profile, isLoading } = useLandlordProfile();
  const { user } = useAuth();

  // Manager-persona users are KYC-exempt by design (the inviting landlord's
  // KYC covers the delegated scope) — treat them as fully verified so the
  // shared landlord verification banner/guard short-circuits cleanly.
  const isManager = user?.profile?.UserType === UserType.Manager;

  // A landlord is verified once they have a confirmed identity document
  // (Emirates ID or passport), or were verified through Persona (legacy — kept
  // for backward compatibility).
  const isVerified =
    isManager ||
    Boolean(profile?.hasConfirmedIdentityDocument) ||
    (profile?.isVerifiedByPersona ?? false);

  return {
    isVerified,
    isLoading,
    profile,
  };
};
